import {
  Actions,
  SET_CURRENT_RESPONSES,
  SET_CURRENT_PROPOSAL_RESPONSE_POV,
  REMOVE_CURRENT_PROPOSAL_RESPONSE,
  ADD_OR_REPLACE_COMMENT_FOR_ARTWORK,
  SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK,
  SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION,
  ADD_CURRENT_ARTWORK_RESPONSE,
  ADD_CURRENT_PLAN_DECORATION_RESPONSE,
  SET_CURRENT_PROPOSAL_RESPONSE_TYPE,
  ADD_CURRENT_POV_RESPONSE,
  REMOVE_COMMENT_FOR_ARTWORK
} from "./actions";
import { State, initialState, CurrentResponse } from "./state";
import {
  PayloadArtwork,
  ProposalComment,
  ResponseTypes,
  PayloadPlanDecoration,
  PayloadPov
} from "../projects";
import Moment from "moment";

/**
 * Add a new response or update existing one
 */
function setCurrentResponseForPOV(state: State, action) {
  const response = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );
  // Response should already exists anyway, just to make sure
  if (!response || !response.response.payload) {
    return state;
  }
  // update payload information
  const payload: PayloadPov = {
    comment: action.comment,
    files: action.files
  };
  const updatedResponse = Object.assign({}, response, {
    response: {
      ...response.response,
      ressourceId: action.ressourceId,
      payload: {
        ...payload
      }
    }
  });
  // add or update response
  const currentResponsesPov = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];

  // Update the state
  return Object.assign({}, state, {
    currentResponses: currentResponsesPov
  });
}
function setCurrentResponseType(state: State, action) {
  const response = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );
  if (!response) {
    return state;
  }
  const updatedResponse = Object.assign({}, response, {
    response: {
      ...response.response,
      responseType: action.responseType
    }
  });
  const currentResponsesType = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];
  return Object.assign({}, state, {
    currentResponses: currentResponsesType
  });
}
/**
 * Generate a payload for an plan decoration response
 * Comments are not handled here
 */
function setResponseForPlanDecoration(state: State, action) {
  const response = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );

  // Response should already exists anyway, just to make sure
  if (!response || !response.response.payload) {
    return state;
  }

  // update payload information
  const payload: PayloadPlanDecoration = {
    cgv: action.payload.cgv,
    comment: action.payload.comment,
    lastVersionTransmitted: action.payload.lastVersionTransmitted
  };

  const updatedResponse = Object.assign({}, response, {
    response: {
      ...response.response,
      ressourceId: action.ressourceId,
      payload
    }
  });
  // add or update response
  const currentResponsesArtworkPayload = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];
  // Update the state
  return Object.assign({}, state, {
    currentResponses: currentResponsesArtworkPayload
  });
}

/**
 * Generate a payload for an artwork response
 * Comments are not handled here
 */
function setResponsePayloadForArtwork(state: State, action) {
  const response = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );

  // Response should already exists anyway, just to make sure
  if (
    !response ||
    !response.response.payload ||
    !(response.response.payload as PayloadArtwork).comments
  ) {
    return state;
  }

  // update payload information
  const payload: PayloadArtwork = {
    comment: action.payload.globalComment,
    askedEveryone: action.payload.askedEveryone,
    summarizedEverything: action.payload.summarizedEverything,
    comments: (response.response.payload as PayloadArtwork).comments,
    files: action.payload.files
  };

  const updatedResponse = Object.assign({}, response, {
    response: {
      ...response.response,
      payload: {
        ...payload
      }
    }
  });
  // add or update response
  const currentResponsesArtworkPayload = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];

  // Update the state
  return Object.assign({}, state, {
    currentResponses: currentResponsesArtworkPayload
  });
}

/**
 * Add or replace a comment to an artwork payload
 */
function addOrReplaceCommentForArtwork(state, action) {
  // find if a response exist with proposalUuid
  const currentResponse = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );

  // Response should exists and should be type artwork, just to make sure
  if (!currentResponse) {
    return state;
  }

  // cast payload as artwork payload
  const artworkPayload = currentResponse.response.payload as PayloadArtwork;

  // Increment id depending if comments already exists or not
  const commentId = artworkPayload.comments.find(c => c.id === action.id)
    ? action.id
    : "tmp-" + Math.round(Math.random() * 10000);

  const newComment: ProposalComment = {
    id: commentId,
    text: action.text,
    x: action.x,
    y: action.y,
    files: action.files
  };
  let updatedComments = artworkPayload.comments;
  const index = artworkPayload.comments.findIndex(p => p.id === newComment.id);

  if (index === -1) {
    updatedComments.push(newComment);
  } else {
    updatedComments = artworkPayload.comments.slice();
    updatedComments.splice(index, 1, newComment);
  }

  const updatedResponse = Object.assign({}, currentResponse, {
    response: {
      ...currentResponse.response,
      payload: {
        ...currentResponse.response.payload,
        comments: updatedComments
      }
    }
  });

  // add or update response
  const currentResponses = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];

  // Update the state
  return Object.assign({}, state, {
    currentResponses
  });
}

/**
 * Remove a comment from arwork proposal
 */
function removeCommentForArtwork(state, action) {
  // find if a response exist with proposalUuid
  const currentResponse = state.currentResponses.find(
    r => r.proposalUuid === action.proposalUuid
  );

  // Response should exists and should be type artwork, just to make sure
  if (!currentResponse) {
    return state;
  }

  // cast payload as artwork payload
  const artworkPayload = currentResponse.response.payload as PayloadArtwork;

  const updatedResponse = Object.assign({}, currentResponse, {
    response: {
      ...currentResponse.response,
      payload: {
        ...currentResponse.response.payload,
        comments: artworkPayload.comments.filter(
          c => c.id.toString() !== action.commentId
        )
      }
    }
  });

  // add or update response
  const currentResponses = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    updatedResponse
  ];

  // Update the state
  return Object.assign({}, state, {
    currentResponses
  });
}

function createCurrentPovResponse(state, action) {
  // Create a current Response
  const currentResponse: CurrentResponse = {
    proposalUuid: action.proposalUuid,
    response: {
      id: 0,
      ressourceId: 0,
      authorId: 0,
      date: Moment(),
      responseType: ResponseTypes.Pending,
      payload: {
        comment: "",
        files: []
      }
    }
  };

  const currentResponses = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposalUuid
    ),
    currentResponse
  ];
  return Object.assign({}, state, {
    currentResponses
  });
}
function createCurrentArtworkResponse(state, action) {
  // If proposal has a pending response, we take it as currentResponse
  // Otherwise we create a new one
  const response = action.proposal.responses.find(
    r => r.responseType === ResponseTypes.Pending
  ) || {
    id: 0,
    ressourceId: action.proposal.ressources[0].id,
    authorId: 0,
    date: Moment(),
    responseType: ResponseTypes.Pending,
    payload: {
      comments: [],
      comment: "",
      askedEveryone: "",
      summarizedEverything: "",
      files: []
    }
  };

  // Create a current Response
  const currentResponse: CurrentResponse = {
    proposalUuid: action.proposal.uuid,
    response
  };
  const currentResponses = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposal.uuid
    ),
    currentResponse
  ];
  return Object.assign({}, state, {
    currentResponses
  });
}
function createCurrentPlanDecorationResponse(state, action) {
  // Create a current Response
  const response: CurrentResponse = {
    proposalUuid: action.proposal.uuid,
    response: {
      id: 0,
      ressourceId: 0,
      authorId: 0,
      date: Moment(),
      responseType: ResponseTypes.Pending,
      payload: {
        comment: "",
        cgv: false,
        lastVersionTransmitted: false
      }
    }
  };
  const currentResponses = [
    ...state.currentResponses.filter(
      r => r.proposalUuid !== action.proposal.uuid
    ),
    response
  ];
  return Object.assign({}, state, {
    currentResponses
  });
}
export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case SET_CURRENT_RESPONSES:
      return Object.assign({}, state, {
        currentResponses: action.currentResponses
      });
    case SET_CURRENT_PROPOSAL_RESPONSE_POV:
      return setCurrentResponseForPOV(state, action);
    case SET_CURRENT_PROPOSAL_RESPONSE_TYPE:
      return setCurrentResponseType(state, action);
    case SET_CURRENT_PROPOSAL_RESPONSE_PAYLOAD_ARTWORK:
      return setResponsePayloadForArtwork(state, action);
    case SET_CURRENT_PROPOSAL_RESPONSE_PLAN_DECORATION:
      return setResponseForPlanDecoration(state, action);
    case ADD_OR_REPLACE_COMMENT_FOR_ARTWORK:
      return addOrReplaceCommentForArtwork(state, action);
    case REMOVE_COMMENT_FOR_ARTWORK:
      return removeCommentForArtwork(state, action);
    case ADD_CURRENT_POV_RESPONSE:
      return createCurrentPovResponse(state, action);
    case ADD_CURRENT_ARTWORK_RESPONSE:
      return createCurrentArtworkResponse(state, action);
    case ADD_CURRENT_PLAN_DECORATION_RESPONSE:
      return createCurrentPlanDecorationResponse(state, action);
    case REMOVE_CURRENT_PROPOSAL_RESPONSE:
      const filterResponse = state.currentResponses.filter(
        r => r.proposalUuid !== action.proposalUuid
      );
      return Object.assign({}, state, {
        currentResponses: filterResponse
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/currentResponses/reducer.ts